module.exports = __webpack_public_path__ + "img/illustration_mobile_por.c546a094.png";